export var defaultConfiguration = {
  rootElement: document.documentElement,
  controllerAttribute: "data-controller",
  actionAttribute: "data-action",
  targetAttribute: "data-target"
};
export function createConfiguration(configuration) {
  return Object.assign({}, defaultConfiguration, configuration);
}